export const articles = [
  {
    id: 1,
    title: '2026年人工智能发展趋势：大模型进入实用化阶段，普通人如何把握机遇',
    summary: '随着大模型技术的不断成熟，AI正在从实验室走向千家万户。本文深入分析2026年AI行业的最新动态，探讨普通人如何在AI时代找到自己的位置。',
    content: `<p>2026年，人工智能技术迎来了前所未有的发展浪潮。从年初各大科技公司密集发布新一代大模型，到年中多个行业级应用落地，AI正在以前所未有的速度改变着我们的生活方式。</p>
    <h3>大模型进入实用化阶段</h3>
    <p>与2024-2025年的探索期不同，2026年的大模型技术在性能大幅提升的同时，部署成本显著下降。据统计，同等性能的模型推理成本已降至两年前的十分之一。这意味着中小企业甚至个人开发者都能负担得起高性能AI服务。</p>
    <p>在应用层面，智能客服、AI写作助手、代码生成工具已经渗透到日常工作和生活中。越来越多的传统行业开始引入AI技术进行数字化转型。</p>
    <h3>普通人如何抓住机遇</h3>
    <p>面对AI浪潮，普通人可以从以下几个方面入手：首先，学习使用主流AI工具，将其融入日常工作流程；其次，关注AI应用层的创业机会，如垂直领域的智能助手；最后，保持持续学习的心态，理解AI的能力边界。</p>
    <p>专家建议，与其担心被AI取代，不如主动学习如何与AI协作。掌握"AI素养"正在成为新时代的核心竞争力。</p>`,
    category: 'keji',
    date: '2026-08-03',
    image: 'https://readdy.ai/api/search-image?query=Modern%20artificial%20intelligence%20visualization%20with%20neural%20network%20patterns%2C%20warm%20orange%20and%20coral%20accents%2C%20clean%20minimal%20background%2C%20futuristic%20yet%20approachable%20tech%20illustration%2C%20soft%20gradient%2C%20editorial%20style%2C%20no%20text&width=1200&height=675&seq=article-1&orientation=landscape',
    author: '科技观察员',
    views: 15280,
    tags: ['人工智能', '大模型', '科技趋势', '2026'],
  },
  {
    id: 2,
    title: '某知名互联网公司高层变动：创始人宣布退休计划，新一代管理层浮出水面',
    summary: '近日，国内某头部互联网公司传出重大人事变动消息。创始人正式宣布退休计划，公司进入新老交替的关键阶段。这一变动将如何影响行业格局？',
    content: `<p>据多方消息确认，国内某顶级互联网科技公司创始人近日在内部全员信中正式宣布了自己的退休计划。这位在中国互联网历史上留下浓墨重彩一笔的企业家，将在未来一年内逐步退出日常管理。</p>
    <h3>交接计划详解</h3>
    <p>根据公开的内部信内容，退休将分为三个阶段进行：第一阶段（未来三个月）将日常运营决策权移交新任CEO；第二阶段（未来六个月）仅保留战略顾问角色；第三阶段（一年后）完全退出公司管理。</p>
    <p>新任CEO由公司内部培养的核心高管接任，该高管在过去五年中主导了公司多项关键业务的转型，业绩斐然。</p>
    <h3>行业影响分析</h3>
    <p>业内人士分析认为，此次交接正值行业竞争格局重塑的关键时期。新管理层面临的挑战包括：在AI赛道保持领先、应对日益激烈的国际化竞争、以及维护庞大用户生态的稳定增长。</p>`,
    category: 'remenzixun',
    date: '2026-08-02',
    image: 'https://readdy.ai/api/search-image?query=Modern%20corporate%20office%20building%20at%20sunset%2C%20warm%20golden%20light%2C%20clean%20architectural%20lines%2C%20professional%20atmosphere%2C%20minimal%20composition%2C%20editorial%20business%20photography%20style%2C%20soft%20shadows&width=1200&height=675&seq=article-2&orientation=landscape',
    author: '商业内参',
    views: 28940,
    tags: ['互联网', '人事变动', '企业管理'],
  },
  {
    id: 3,
    title: '娱乐圈年度大瓜：顶流明星夫妻疑似婚变，社交媒体已互相取关',
    summary: '近日，娱乐圈再次掀起波澜。一对被视为模范夫妻的顶流明星被网友发现已在社交媒体上互相取关，引发广泛猜测。',
    content: `<p>8月1日深夜，有细心的网友发现某对顶级流量明星夫妻在多个社交平台上的互动记录全部消失，且已互相取消关注。这一发现迅速在各大社交平台引发热议，相关话题在数小时内获得超过3亿次阅读。</p>
    <h3>时间线回顾</h3>
    <p>这对明星夫妻于2022年在一档热门综艺节目中相识，2023年高调宣布恋情，2024年初举办了轰动一时的豪华婚礼。婚后两人频繁在社交媒体上秀恩爱，被粉丝称为"娱乐圈最甜夫妻"。</p>
    <p>然而自2026年6月起，两人在公开场合的互动明显减少。最后一次同框出现在6月中旬的一场颁奖典礼上，当时已有媒体注意到两人全程无眼神交流。</p>
    <h3>当事人回应</h3>
    <p>截至发稿时，双方工作室均未对此事做出正式回应。据接近当事人的知情人士透露，两人目前处于分居状态，具体原因尚不明确。</p>`,
    category: 'chigua',
    date: '2026-08-02',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20entertainment%20theme%20with%20warm%20dramatic%20lighting%2C%20soft%20coral%20and%20gold%20tones%2C%20theatrical%20atmosphere%2C%20minimal%20composition%2C%20editorial%20style%2C%20no%20text%20or%20people&width=1200&height=675&seq=article-3&orientation=landscape',
    author: '娱乐记者小王',
    views: 67200,
    tags: ['娱乐圈', '明星', '婚变', '吃瓜'],
  },
  {
    id: 4,
    title: '最新数据：2026上半年国内智能手机出货量排行榜出炉，国产品牌强势崛起',
    summary: '调研机构发布2026年上半年国内智能手机市场报告。数据显示，国产手机品牌市场份额持续攀升，高端市场突破取得关键进展。',
    content: `<p>知名市场调研机构Counterpoint于8月1日发布了2026年第二季度及上半年中国智能手机市场报告。数据显示，2026年上半年中国智能手机出货量达到1.42亿部，同比增长4.8%，市场整体呈现回暖态势。</p>
    <h3>品牌排名变化</h3>
    <p>最引人注目的是国产手机品牌在高端市场（6000元以上价位段）的突破。国产品牌在该价位段的合计市场份额从去年同期的28%跃升至42%，增幅显著。其中AI功能的深度整合被认为是推动高端化的最关键因素。</p>
    <h3>消费者偏好转变</h3>
    <p>报告还指出，2026年消费者购机时最关注的三大因素分别是：AI功能（38%）、影像能力（27%）和续航表现（18%）。这与此前"性价比优先"的消费心态形成了鲜明对比。</p>`,
    category: 'keji',
    date: '2026-08-01',
    image: 'https://readdy.ai/api/search-image?query=Sleek%20modern%20smartphone%20on%20minimal%20desk%20setup%2C%20warm%20ambient%20lighting%2C%20clean%20product%20photography%20style%2C%20soft%20shadows%2C%20elegant%20composition%2C%20orange%20and%20cream%20color%20palette&width=1200&height=675&seq=article-4&orientation=landscape',
    author: '数码评测师',
    views: 12450,
    tags: ['智能手机', '国产手机', '市场数据', '科技'],
  },
  {
    id: 5,
    title: '夏日健康提醒：高温天气下的饮食与运动指南，这些误区一定要避开',
    summary: '全国多地持续高温，如何科学应对酷暑天气？营养学专家和运动医学专家联合给出专业建议，帮您健康度夏。',
    content: `<p>入夏以来，全国多地气温持续攀升，多个城市连续发布高温红色预警。在如此极端天气条件下，如何科学地安排饮食和运动，成为许多人关心的话题。</p>
    <h3>饮食篇：补水不等于狂喝水</h3>
    <p>很多人认为天热就应该大量喝水，但专家指出这是一个常见误区。短时间内大量饮用白水可能导致体内电解质失衡，严重时甚至引发水中毒。正确的做法是少量多次、主动补水，并适当补充含电解质的饮品。</p>
    <p>在食物选择上，夏季宜多食用含水量高的蔬果，如西瓜、黄瓜、番茄等。同时要注意蛋白质的摄入，避免因食欲下降导致营养不均衡。</p>
    <h3>运动篇：避开高温时段</h3>
    <p>运动医学专家建议，夏季户外运动应严格避开上午10点至下午4点的高温时段。可选择清晨或傍晚进行适量运动，运动时长控制在30-45分钟为宜。运动后不要立即进入空调房或用冷水冲凉，应先在阴凉处休息15-20分钟让身体自然降温。</p>`,
    category: 'jiankang',
    date: '2026-08-01',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20healthy%20summer%20lifestyle%20scene%20with%20fruits%20and%20water%2C%20bright%20warm%20natural%20light%2C%20clean%20minimal%20composition%2C%20soft%20sage%20green%20and%20cream%20tones%2C%20editorial%20wellness%20photography&width=1200&height=675&seq=article-5&orientation=landscape',
    author: '健康生活编辑',
    views: 8930,
    tags: ['健康', '夏季养生', '饮食指南', '运动'],
  },
  {
    id: 6,
    title: '震惊！某选秀节目选手被曝学历造假，节目组连夜发声明',
    summary: '热门选秀节目《星光创造营》选手陷入学历造假风波。网友扒出其自称的海外名校学历实为短期培训课程，引发舆论哗然。',
    content: `<p>8月1日晚间，正在热播的选秀节目《星光创造营2026》突然陷入舆论漩涡。一名人气选手被网友爆料其自称的"美国纽约大学音乐系学士"学历存在严重造假嫌疑，实际仅为该校一个为期两周的暑期培训项目。</p>
    <h3>造假细节曝光</h3>
    <p>据爆料网友提供的信息，该选手在节目中多次提到自己的留学经历，并在个人简历中明确标注"纽约大学音乐学士"。然而经查证，纽约大学音乐系并无该选手的学位记录，其实际参加的是该校继续教育学院面向社会人士开放的短期音乐工作坊，学费仅需2800美元。</p>
    <h3>节目组紧急回应</h3>
    <p>事件发酵后，节目组于当晚连夜发布声明，表示已注意到相关舆情，正在与选手本人核实情况，若核实属实将严肃处理，绝不姑息。</p>`,
    category: 'chigua',
    date: '2026-08-01',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20stage%20lighting%20with%20spotlight%20effect%2C%20warm%20coral%20and%20dark%20ambient%20tones%2C%20theatrical%20atmosphere%2C%20abstract%20entertainment%20concept%2C%20minimal%20composition%2C%20editorial%20style&width=1200&height=675&seq=article-6&orientation=landscape',
    author: '娱乐前线',
    views: 45100,
    tags: ['选秀', '学历造假', '综艺节目', '吃瓜'],
  },
  {
    id: 7,
    title: '股票市场重大消息：央行宣布新一轮降准，A股三大指数集体高开',
    summary: '央行宣布下调金融机构存款准备金率0.5个百分点，释放长期流动性约1.2万亿元。A股市场反应积极，分析师普遍看好后市。',
    content: `<p>8月2日盘前，中国人民银行发布公告，决定于2026年8月15日下调金融机构存款准备金率0.5个百分点（不含已执行5%存款准备金率的金融机构）。此次降准预计释放长期资金约1.2万亿元。</p>
    <h3>政策背景分析</h3>
    <p>分析人士指出，此次降准是年内第二次，距离上次降准仅隔四个月，政策力度超出市场预期。这反映了在当前经济复苏进程中，决策层对流动性的重视程度。</p>
    <p>降准消息公布后，A股三大指数集体高开。其中上证指数开盘涨幅超过1.2%，深证成指涨1.5%，创业板指涨2.1%。金融、地产板块领涨。</p>
    <h3>后市展望</h3>
    <p>多家券商在盘后发布研报，普遍认为降准将对股市形成中期利好。但同时也提醒投资者注意，降准的传导效应需要时间才能在实体经济中完全体现。</p>`,
    category: 'caijing',
    date: '2026-08-02',
    image: 'https://readdy.ai/api/search-image?query=Modern%20financial%20district%20skyline%20with%20warm%20golden%20sunset%20light%2C%20clean%20architectural%20photography%2C%20professional%20business%20atmosphere%2C%20sleek%20glass%20buildings%2C%20minimal%20composition%2C%20soft%20warm%20tones&width=1200&height=675&seq=article-7&orientation=landscape',
    author: '财经日报',
    views: 18700,
    tags: ['股市', '降准', '财经新闻', 'A股'],
  },
  {
    id: 8,
    title: '2026高考改革最新消息：多地推行"3+1+2"新模式，考生如何科学选科',
    summary: '教育部发布高考综合改革推进方案，多个省份确定将从2027届高一新生开始实行"3+1+2"新高考模式。面对新变化，考生和家长该如何应对？',
    content: `<p>教育部官网近日发布了《关于进一步深化高考综合改革的指导意见》，明确了下一阶段高考改革的路线图和时间表。根据文件内容，多个尚未启动新高考改革的省份将在2027年秋季入学的高一新生中开始实施"3+1+2"模式。</p>
    <h3>"3+1+2"模式详解</h3>
    <p>"3"指的是语文、数学、外语三门全国统考科目；"1"为首选科目，考生须在物理和历史中选择一门；"2"为再选科目，考生可在化学、生物、思想政治、地理四科中选择两门。这一模式旨在兼顾学生的个性化发展需求和高校人才选拔的科学性。</p>
    <h3>选科建议</h3>
    <p>教育专家建议，考生选科时应综合考虑三个因素：个人兴趣特长、目标大学专业的选科要求、以及所在学校的教学资源优势。切勿盲目跟风选择"热门组合"，适合自己的才是最好的选择。</p>`,
    category: 'jiaoyu',
    date: '2026-07-31',
    image: 'https://readdy.ai/api/search-image?query=Modern%20educational%20environment%20with%20books%20and%20warm%20lighting%2C%20clean%20minimal%20study%20space%2C%20soft%20natural%20light%2C%20inspirational%20atmosphere%2C%20editorial%20style%2C%20sage%20green%20and%20cream%20tones&width=1200&height=675&seq=article-8&orientation=landscape',
    author: '教育观察',
    views: 21500,
    tags: ['高考改革', '教育政策', '选科指导'],
  },
  {
    id: 9,
    title: '生活小妙招：这5个家电清洁误区让电器寿命减半，99%的人都中招了',
    summary: '家电维修师傅总结多年经验，列出日常生活中最常见的家电清洁误区。快来看看你中了几条，学会正确方法让家电多用五年。',
    content: `<p>随着生活水平的提高，家中电器越来越多，但很多人对电器的清洁保养却存在诸多误区。资深家电维修师傅老张从业二十年，总结了最常见的五个清洁误区，希望能帮大家延长家电使用寿命。</p>
    <h3>误区一：用湿抹布直接擦电视屏幕</h3>
    <p>液晶电视屏幕表面有特殊的涂层，直接用湿抹布擦拭可能导致涂层脱落，形成永久性斑点。正确做法是使用专用的屏幕清洁剂和超细纤维布，轻轻擦拭。</p>
    <h3>误区二：空调滤网一年才洗一次</h3>
    <p>空调滤网应该每两周到一个月清洗一次，长时间不清洗不仅影响制冷效果，耗电量增加30%以上，还容易滋生细菌引发呼吸道疾病。</p>
    <h3>误区三至五</h3>
    <p>冰箱密封条用洗洁精清洗、洗衣机从不清洁内筒、微波炉用金属刷清洗——这些都是非常普遍的错误做法，每种都可能对电器造成不可逆的伤害。</p>`,
    category: 'shenghuo',
    date: '2026-07-31',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20home%20appliance%20setup%20in%20bright%20kitchen%2C%20warm%20natural%20lighting%2C%20minimal%20interior%20design%2C%20fresh%20and%20clean%20atmosphere%2C%20editorial%20lifestyle%20photography%2C%20cream%20and%20warm%20wood%20tones&width=1200&height=675&seq=article-9&orientation=landscape',
    author: '生活达人',
    views: 34500,
    tags: ['生活妙招', '家电清洁', '实用技巧'],
  },
  {
    id: 10,
    title: '某知名导演新片拍摄现场意外曝光，豪华阵容引网友疯狂期待',
    summary: '知名导演陈导的新片被网友偶遇拍摄现场，流出的路透照显示该片云集了多位一线明星。影片预计将在2027年春节档上映。',
    content: `<p>8月1日下午，有网友在某影视基地附近偶遇了知名导演陈导的新片拍摄现场，并拍摄了一组路透照片上传至社交平台。照片中可见多位一线明星正在片场进行拍摄工作，阵容之豪华引发网友热议。</p>
    <h3>主创阵容盘点</h3>
    <p>从流出的路透照来看，影片已确认的主演包括2025年金鸡奖最佳男主角得主、2024年百花奖影后，以及三位实力派中生代演员。此外，据知情人士透露，还有两位国际影星将客串出演。</p>
    <h3>影片信息推测</h3>
    <p>根据路透照中的场景布置和演员造型，网友推测该片可能是一部古装历史题材大制作。此前陈导曾在采访中透露正在筹备一部"前所未有的史诗级作品"，此次路透或为该项目的首次曝光。</p>`,
    category: 'yule',
    date: '2026-07-30',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20production%20scene%20with%20warm%20dramatic%20lighting%2C%20movie%20set%20atmosphere%2C%20professional%20film%20equipment%2C%20artistic%20composition%2C%20soft%20coral%20and%20gold%20tones%2C%20editorial%20style&width=1200&height=675&seq=article-10&orientation=landscape',
    author: '影视圈内人',
    views: 38700,
    tags: ['电影', '明星阵容', '娱乐新闻'],
  },
  {
    id: 11,
    title: '国际局势新变化：G20峰会达成重要共识，全球经济合作迎来新篇章',
    summary: 'G20领导人峰会于昨日闭幕，与会各国在贸易自由化、气候变化合作、数字经济治理等关键议题上达成广泛共识，国际社会给予高度评价。',
    content: `<p>经过为期三天的密集磋商，G20领导人峰会于7月30日在主办国顺利闭幕。本届峰会围绕"共同复苏、强劲复苏"的主题，取得了多项突破性成果。</p>
    <h3>核心成果一览</h3>
    <p>峰会最重要的成果是各方一致同意重启多边贸易谈判进程，承诺在未来两年内就数字贸易规则达成框架协议。此外，在气候变化融资方面，发达国家承诺将每年1000亿美元的气候资金目标提前至2026年底实现。</p>
    <h3>中国的角色与贡献</h3>
    <p>作为全球第二大经济体，中国在本届峰会上提出了"数字丝绸之路"升级版倡议，并宣布设立规模为200亿美元的全球数字经济发展基金。此举获得了与会各国尤其是发展中国家的广泛赞誉。</p>`,
    category: 'remenzixun',
    date: '2026-07-30',
    image: 'https://readdy.ai/api/search-image?query=Modern%20international%20diplomatic%20conference%20setting%2C%20warm%20professional%20atmosphere%2C%20clean%20architectural%20space%2C%20flags%20arrangement%2C%20editorial%20style%2C%20soft%20golden%20lighting%2C%20minimal%20composition&width=1200&height=675&seq=article-11&orientation=landscape',
    author: '国际观察',
    views: 13200,
    tags: ['国际新闻', 'G20', '全球经济'],
  },
  {
    id: 12,
    title: '养生辟谣：喝柠檬水能美白？吃猪蹄能补胶原？这些养生谣言别再信了',
    summary: '网络上流传着各种各样的养生"常识"，但其中不少缺乏科学依据。我们请来了三甲医院营养科主任，为大家逐一辟谣。',
    content: `<p>随着健康意识的提高，越来越多的人开始关注养生。然而，网络上流传的一些养生"常识"其实并不科学，甚至可能对健康造成危害。我们特别邀请了某三甲医院营养科主任医师李教授，为大家澄清几个最常见的养生误区。</p>
    <h3>谣言一：喝柠檬水能美白</h3>
    <p>李教授指出，柠檬中确实含有维生素C，但饮用柠檬水后维生素C进入消化系统，并不会直接作用于皮肤。而且柠檬水的维生素C含量有限，要达到美白效果需要大量摄入。更重要的是，柠檬具有光敏性，白天大量饮用反而可能使皮肤对紫外线更敏感。</p>
    <h3>谣言二：吃猪蹄补充胶原蛋白</h3>
    <p>胶原蛋白是大分子蛋白质，口服后会被消化系统分解为氨基酸，并不会直接补充到皮肤中。猪蹄中的胶原蛋白吸收率极低，而且猪蹄脂肪含量高，过量食用反而可能导致肥胖。</p>
    <h3>科学养生建议</h3>
    <p>真正的健康养生应该建立在均衡饮食、适度运动和良好作息的基础上，而不是依赖某一种"神奇食物"。</p>`,
    category: 'jiankang',
    date: '2026-07-29',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20healthy%20ingredients%20on%20wooden%20table%2C%20natural%20warm%20lighting%2C%20lemons%20and%20herbs%2C%20clean%20minimal%20food%20photography%2C%20editorial%20wellness%20style%2C%20soft%20cream%20and%20sage%20green%20tones&width=1200&height=675&seq=article-12&orientation=landscape',
    author: '健康辟谣站',
    views: 56300,
    tags: ['养生', '辟谣', '健康科普'],
  },
];

export const hotTags = ['人工智能', '吃瓜', '明星', 'A股', '高考', '养生', '手机', '电影', '降准', '选秀'];

export const siteInfo = {
  name: '51网址导航',
  fullName: '51网址导航',
  slogan: '上网从这里开始',
  description: '51网址导航是一个综合性上网导航平台，提供网址导航123快捷入口，集成123导航、导航123等数字标识导航服务。网址123，易记好用的上网导航，为您提供网址导航、热点资讯、吃瓜事件等一站式服务。',
  founded: '2020年',
  domain: 'vfufj.cn',
  email: 'contact@51nav.com',
  phone: '400-888-5151',
  address: '北京市海淀区中关村科技园区',
};